import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { OnboardingClientConfigService } from '@zero/onboarding/domain';
import { filter } from 'rxjs';
import { BaseComponent } from '../../components/base.component';
import { OnboardingContainerComponent } from '../../components/onboarding-container/onboarding-container.component';

@Component({
  imports: [OnboardingContainerComponent, TranslocoPipe, AsyncPipe],
  templateUrl: './provision.component.html',
})
export class ProvisionComponent extends BaseComponent implements OnInit {
  public readonly onboardingClientConfigService = inject(OnboardingClientConfigService);

  public showAgreement1: boolean;
  public showAgreement2: boolean;

  readonly #destroyRef = inject(DestroyRef);

  override ngOnInit(): void {
    super.ngOnInit();
    this.onboardingClientConfigService.triggerLoadClientConfigForContractExcerpts();
  }

  protected override populateFromData(): void {
    // nothing to do
  }

  protected override listenToSuccessfulSubmit(): void {
    this.facade.sentProvisionInformationSuccessfully$
      .pipe(
        filter((sent) => sent),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.facade.goToNextStep());
  }

  protected override submit() {
    this.facade.sendProvisionInformation({
      acceptCommissionForwarding: true,
      acceptGrants: true,
      acceptPreContractualInformation: true,
      allInformationCorrect: true,
      ownCalculation: true,
      acceptNoAdvice: true,
    });
  }
}
